// extracted by mini-css-extract-plugin
export default {"nav":"Pagination_nav__HASjw"};